module.exports = __webpack_public_path__ + "img/img-gmo-process@2x.ab8a93bd.png";